<template>
  <div class="px-2">
    <div v-if="$router.currentRoute.name === 'passengers-phone-blacklist'">
      <h1 class="text-xs-center">Phone Blacklist</h1>

      <div class="layout justify-end mb-3">
        <v-btn
          v-if="isAdmin"
          color="primary"
          :disabled="apiInProgress"
          @click="openNew"
        >
          <v-icon left small>fal fa-plus</v-icon>
          Blacklist phone
        </v-btn>
      </div>

      <v-layout row wrap>
        <v-flex md6 sm8 pa-2>
          <form @submit.prevent="() => refresh(1)">
            <v-text-field
              solo
              v-model="searchKeywords"
              append-icon="fal fa-search"
              :disabled="apiInProgress"
              type="search"
              clearable
              placeholder="Search phone number"
              @click:clear="() => refresh(1)"
              @click:append="() => refresh(1)"
            />
          </form>
        </v-flex>
      </v-layout>

      <v-data-table
        :headers="headers"
        :items="records"
        :pagination.sync="pagination"
        :total-items="total"
        :loading="apiInProgress"
        :rows-per-page-items="[10, 25, 50]"
        @update:pagination="onPagination"
        class="elevation-1"
        must-sort
      >
        <template v-slot:items="props">
          <tr>
            <td>{{ props.item.phoneNumberLabel }}</td>
            <td>
              <v-chip small :color="props.item.threatLevel === 2 ? 'warning' : 'default'">
                {{ props.item.threatLevelLabel }}
              </v-chip>
            </td>
            <td>{{ props.item.dateCreatedLabel }}</td>
            <td>{{ props.item.dateUpdatedLabel }}</td>
            <td>
              <v-icon v-if="props.item.dateRestored" small color="success">fas fa-check-circle</v-icon>
              {{ props.item.dateRestoredLabel }}
            </td>
            <td class="text-xs-right">
              <v-btn small icon @click="openRecord(props.item)">
                <v-icon small>fas fa-pencil</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>

    <router-view :signed-in-user="signedInUser" />
  </div>
</template>

<script>
import src from './src'
export default src
</script>
